import moment, { Moment } from 'moment-timezone';

/**
 * Calculate age of a datetime
 *
 * @param {Moment} datetime datetime that tipically will come from gizmo data
 * @returns
 */
function age(datetime: Moment) {
  if (typeof datetime === 'string') {
    const regex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z$/;
    if (regex.test(datetime)) {
      datetime = moment(datetime);
    }
  }

  if (moment.isMoment(datetime)) {
    const calculatedAge = moment().diff(datetime, 'years');

    if (calculatedAge >= 0) {
      return calculatedAge;
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
}

export default age;
